module.exports = __webpack_public_path__ + "static/media/tocaCampaign.a25c6dfa.png";